import { FaPlay, FaPause, FaStepBackward, FaStepForward } from "react-icons/fa";
import {
  TrackCardWrapper,
  CoverWrapper,
  CoverImage,
  Overlay,
  InfoOverlay,
  Controls,
  TrackCardTip,
  SpotifyNotice,
} from "./TrackCardStyles";
import EmbedPlayer from "../embedPlayer/EmbedPlayer";
import { TrackCardProps } from "../../types/componentsConstructors";

const TrackCard = ({
  index,
  currentIndex,
  isPlaying,
  onPlay,
  onPause,
  onNext,
  onPrev,
  name,
  url,
  imageUrl,
}: TrackCardProps) => {
  const isActive = index === currentIndex;
  const hasImage = !!imageUrl;
  const isSpotify = url.includes("spotify.com");

  if (!hasImage) {
    return (
      <TrackCardWrapper>
        <TrackCardTip>
          🎧 Dica: adicione uma imagem de capa na sua track para deixá-la mais
          profissional no seu Press Kit
        </TrackCardTip>
      </TrackCardWrapper>
    );
  }

  return (
    <TrackCardWrapper isActive={isActive}>
      <CoverWrapper>
        <CoverImage src={imageUrl} alt={name} />
        <Overlay>
          <InfoOverlay>
            <strong>{name}</strong>
            {isSpotify && (
              <SpotifyNotice>Abrirá o Spotify em nova aba</SpotifyNotice>
            )}
          </InfoOverlay>
          <Controls>
            <FaStepBackward onClick={onPrev} />
            {isActive && isPlaying ? (
              <FaPause onClick={onPause} />
            ) : (
              <FaPlay onClick={onPlay} />
            )}
            <FaStepForward onClick={onNext} />
          </Controls>
        </Overlay>
      </CoverWrapper>

      {isActive && (
        <div style={{ marginTop: 12 }}>
          <EmbedPlayer url={url} isPlaying={isPlaying} />
        </div>
      )}
    </TrackCardWrapper>
  );
};

export default TrackCard;
